import { getRuntimeConfigOrDefault } from '../utils/runtime-config';

// OAuth configuration with runtime support - using getters for lazy evaluation
export const oauthConfig = {
  google: {
    // Use runtime config first, then process.env, then default
    get clientId() {
      return getRuntimeConfigOrDefault('REACT_APP_GOOGLE_CLIENT_ID', '1234567890-abcdefghijklmnopqrstuvwxyz123456.apps.googleusercontent.com');
    },
    redirectUri: getRuntimeConfigOrDefault('REACT_APP_GOOGLE_REDIRECT_URI', 'http://localhost:3000/auth/google/callback'),
    scope: 'openid profile email'
  },
  linkedin: {
    get clientId() {
      return getRuntimeConfigOrDefault('REACT_APP_LINKEDIN_CLIENT_ID', 'YOUR_LINKEDIN_CLIENT_ID');
    },
    get clientSecret() {
      return getRuntimeConfigOrDefault('REACT_APP_LINKEDIN_CLIENT_SECRET', '');
    },
    redirectUri: getRuntimeConfigOrDefault('REACT_APP_LINKEDIN_REDIRECT_URI', 'http://localhost:3000/auth/linkedin/callback'),
    scope: 'openid profile email'
  },
  api: {
    get baseUrl() {
      return getRuntimeConfigOrDefault('REACT_APP_API_URL', 'http://localhost:3001/api');
    }
  }
};

// LinkedIn OAuth URLs
export const linkedInAuthUrl = (state: string) => {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: oauthConfig.linkedin.clientId,
    redirect_uri: oauthConfig.linkedin.redirectUri,
    state,
    scope: oauthConfig.linkedin.scope
  });

  return `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`;
};